export const openCamera = (): Promise<Blob | null> => {
  return new Promise<Blob | null>((resolve) => {
    let hasSettled = false;

    const settle = (blob: Blob | null) => {
      if (hasSettled) return;
      hasSettled = true;
      input.remove();
      resolve(blob);
    };

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.display = 'none';

    input.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        settle(target.files[0]);
      } else {
        settle(null);
      }
    };
    input.addEventListener('cancel', () => settle(null));

    document.body.append(input);
    input.click();
  });
};
